<div class="modal-body p-4">
    <div (click)="closeModal()" class="close-modal me-n4 mt-n4">
        <app-icon [type]="'ThinCross'"></app-icon>
    </div>
    <h3 class="modal-title mb-7">Unfinished Questions</h3>
    <p class="mb-4">You have not submitted the following questions:</p>
    <ng-container *ngFor="let slide of studentAssignment.slides">
        <ng-container *ngIf="isQuestionSlide(slide) && getUnansweredQuestions(slide)">
            <p class="mb-1">slide: {{ slide.name }}</p>
            <p class="mb-4">questions: {{ getUnansweredQuestions(slide) }}</p>
        </ng-container>
    </ng-container>
    <p class="mt-7">
        Are you sure you want to finish the lesson without completing these questions?
    </p>
    <div class="row-auto mt-9">
        <div class="col d-flex flex-row justify-content-end">
            <app-button (click)="closeModal()" [buttonClasses]="'hallow'" class="me-4">
                No, cancel
            </app-button>
            <app-button (click)="submit()" [disable]="!isSubmitEnabled">
                Yes, finish lesson
            </app-button>
        </div>
    </div>
</div>
